<template>
    <div>
        <div style="color: #00ff96;font-size: 1rem">申请盘点</div>
        <form :form="detail">
            <div style="display: flex;justify-content: space-between;">
                <SelectField labelWidth="40%" label="盘点负责人" style="margin: 0.5rem 0.2rem;width:45%" id="applicantId"
                             :modelValue="detail.applicantId" :options="userList" required
                             @update:modelValue="(value) => handleModelValueUpdate('applicantId', value)"
                />
                <DatePickerField labelWidth="40%" label="盘点开始时间" required style="margin: 0.1rem 0.1rem 0.1rem 0;width:45%"
                                 id="inventoryTime"
                                 name="inventoryTime" placeholder="请选择日期"
                                 :rules="[{ required: true, message: '请选择日期' }]"
                                 :modelValue="detail.inventoryTime"
                                 @update:modelValue="(value) => handleModelValueUpdate('inventoryTime', value)"
                />
            </div>
            <div>
                <TextareaField :modelValue="detail.reason" id="reason" required labelWidth="14%" style="margin: 0.5rem 0.2rem" label="盘点说明"
                               @update:modelValue="(value) => handleModelValueUpdate('reason', value)"
                />
                <TextareaField :modelValue="detail.remark" labelWidth="14%" style="margin: 0.5rem 0.2rem" label="备注"
                               id="remark"  @update:modelValue="(value) => handleModelValueUpdate('remark', value)"
                />
            </div>
            <div class="formDiv">
                <div style="display: flex;justify-content: start">
                    <div style="width:10%;margin:1rem 0 1rem 1rem;color:#8290a7;">附件</div>
                    <Upload :list="fileList" @change="(list) => (fileList = list)" />
                </div>
            </div>
            <div class="formDiv">
                <Goods :selected="selected" @close-add-modal="handleCloseAddModal"/>
            </div>
            <div class="formButton">
                <a-space>
                    <ButtonField text="关闭" @click="cancel" secondary />
                    <ButtonField text="保存" primary @click="handleSubmit"/>
                </a-space>
            </div>
        </form>
    </div>
</template>

<script>
import { edit, fetchDetail } from "../api/check";
import Goods from "./components/goods.vue";
import moment from "moment";
import { mapState } from "vuex";
export default {
  components: {
    Goods,
  },

  data() {
    return {
      form: this.$form.createForm(this),
      detail: {},
      selected: [],
      fileList: [],
      loading: false,
    };
  },

  computed: {
    ...mapState("userSelector", ["userList"]),
  },

  mounted() {
    fetchDetail({
      id:this.id,
    }).then((res) => {
      if (res) {
        this.detail = res;
        this.selected = Array.isArray(this.detail.materialList)
          ? this.detail.materialList
          : [];
        this.fileList = res.attachmentList ? res.attachmentList : [];
      }
    });
  },
  props:{
     id:{
        type:String,
        required:true
     }
  },
  methods: {
    handleModelValueUpdate(fieldName, value) {
        this.detail[fieldName] = value;
    },
    moment,
    handleSubmit() {
        if (this.isSubmitting) return;
        this.isSubmitting = true;
        if (!this.detail.applicantId) {
            this.$message.error('盘点负责人不能为空');
            this.isSubmitting = false;
            return;
        }
        if (!this.detail.inventoryTime) {
            this.$message.error('盘点开始时间不能为空');
            this.isSubmitting = false;
            return;
        }
        if (!this.detail.reason) {
            this.$message.error('盘点说明不能为空');
            this.isSubmitting = false;
            return;
        }
        edit({
          ...this.detail,
          applicant: this.userList.find(
            (item) => item.id === this.detail.applicantId
          ).name,
          inventoryTime: this.detail.inventoryTime.format("YYYY-MM-DD"),
          materialList: this.selected.map((item) => {
            return {
              // mid: item.mid ? item.mid : item.id,
              id: item.id,
              code: item.code,
              name: item.name,
              brand: item.brand,
              specification: item.specification,
              unit: item.unit,
              price: item.price,
            };
          }),

          attachments: this.fileList.map((item) => item.id).join(","),
        })
          .then(() => {
            this.cancel();
          })
          .finally(() => {
            this.loading = false;
          });
    },

    cancel() {
        this.$emit('show-check-index');
    },
    handleCloseAddModal() {
        this.visible = false;
    }
  },
};
</script>

<style scoped>
.formButton{
    width: 100%;
    text-align: center;
    margin: 1rem 0;
}
</style>

